import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType } from '../../constants';

export class GATrackingPDPRegisterAsBusinessInteractionEvent implements GATrackingEvent {
  constructor(private payload: any){}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.PDPRegisterAsBusiness;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.PDPRegisterAsBusiness,
      label: this.payload.label,
      gtmCustom: {
        category: this.payload.category
      }
    };
  }
}
